module.exports = __webpack_public_path__ + "static/media/checking.15bcacbf.png";